import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import CityCard from './CityCard';
import CityService from '../../../services/CityService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  cityCard: {
    height: '100%'
  }
}));

const CityList = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const foo = async () => {
      const fetchData = typeof id !== 'undefined'
        ? await CityService.getById(id)
        : await CityService.getAll();

      if (fetchData?.code === 200) {
        if (id) {
          setCities([fetchData.data]);
        } else {
          setCities(fetchData.data);
        }
      }
    };

    foo();
  }, [id]);

  return (
    <Page
      className={classes.root}
      title="Ciudades"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
          <Grid
            container
            spacing={3}
          >
            {cities.map((city) => (
              <Grid
                item
                key={city.id}
                lg={4}
                md={6}
                xs={12}
              >
                <CityCard
                  className={classes.cityCard}
                  city={city}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
        >
          <Pagination
            color="primary"
            count={3}
            size="small"
          />
        </Box>
      </Container>
    </Page>
  );
};

export default CityList;
